import './NuiHeader.less';
import React from 'react';

export interface NuiHeaderProps {
    title: string;
    subTitle: string;
    onPhone?: boolean;
    iconBackground?: string;
    colorBackground?: string;
}

export default function NuiHeader({ title, subTitle, iconBackground, colorBackground = '#ff8001' }: NuiHeaderProps) {
    const backgroundImage = {
        background: colorBackground,
        backgroundImage: `url(${iconBackground})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    };
    return (
        <header className="nui-header-component" style={backgroundImage}>
            <h1 className="nui-header-title nui-header-text-line-clamp">{title}</h1>
            <p className="nui-header-subtitle nui-header-text-line-clamp nui-header-mobile-subtitle">{subTitle}</p>
        </header>
    );
}
